<template>
  <el-card :body-style="{ padding: '8px 0' }" class="mt-2">
    <div class="sequence-suggestions-item">
      <div class="sequence-suggestions-item-icon">
        <div class="round-icon" :style="{ backgroundColor: iconBgColor }">
          <font-awesome-icon :icon="icon" :color="iconFgColor" />
        </div>
      </div>
      <div class="sequence-suggestions-item-content">
        <el-button size="mini" @click="onAddItem" style="float: right; margin-right: 8px">Use</el-button>
        <h5 v-html="titleHtml"></h5>
        <p style="width: 200px">{{description_short}}</p>
        <a v-if="href" :href="href" target="_blank">
          <font-awesome-icon icon="external-link-alt" />
          find out more
        </a>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  props: {
    itemId: {
      required: true
    },
    titleHtml: {
      default: 'Title'
    },
    href: {},
    description: {
      default: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
    },
    iconBgColor: {
      default: 'red'
    },
    iconFgColor: {
      default: 'white'
    },
    icon: {
      default: 'hourglass-start'
    },
    // TODO: allow custom images
  },
  computed: {
    description_short() {
      return this.description;
    }
  },
  methods: {
    onAddItem() {
      this.$emit('add', this.itemId)
    }
  }
}
</script>

<style>
.sequence-suggestions-item h5 {
  margin: 0;
}
.sequence-suggestions-item p {
  margin: 5px 10px 5px 0;
  text-align: justify;
  line-height: 1.25em;
}
.sequence-suggestions-item {
  display: flex;
}
.sequence-suggestions-item-icon {
  width: 60px
}
.sequence-suggestions-item-content {
  flex: auto;
}
.sequence-suggestions-item h5 strong {
  background-color: yellow;
}
/* MOVE TO global CSS */
/* .sequence-suggestions-item-icon */ .round-icon {
  border-radius: 50%;
  text-align: center;
  margin: 2px 10px 0 10px;
  width: 40px;
  height: 40px;
  position: relative;
}
/* .sequence-suggestions-item-icon */ .round-icon > * {
  top: 10px;
  position: absolute;
  width: 20px !important;
  height: 20px;
  left: 10px;
}
.round-icon--red {
  background-color: red;
}
</style>
